import LoginInvite from '@/features/loginInvite/index.vue';
import { debounce } from 'lodash-es';
import { useDefaultModal } from './defaultModal';

export const useLoginInviteModal = debounce((params: any) => {
  const cancel = () => {
    modal.destroy();
  };

  const modal = useDefaultModal({
    title: params.title,
    width: 500,
    center: true,
    content: [
      // <CloseOutlined class={CloseIconOutClass} onClick={cancel} />,
      <LoginInvite cancel={cancel} {...params} />,
    ],
    wrapClassName: 'yy-invite-modal',
    footer: false,
  });

  return modal;
}, 200);
